import { createContext } from "react";
import { IBrandContext } from "../../types";

const BrandContext = createContext({} as IBrandContext);
BrandContext.displayName = "BrandContext";

export default BrandContext;
